<template>
  <ol class="multi-steps">
    <li v-for="(item, index) in items" :key="item.name" :class="{'is-active': isActive == index}" :aria-current="isActive == index ? 'step' : false">{{item.name}}</li>
  </ol>
</template>

<script>
export default {
  name: "EbMultisteps",
  props: {
    items: {
      type: Array,
      default: () => ([])
    },
    isActive: {
      type: Number,
      default: 0
    }
  },
}
</script>